import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useState, useEffect } from 'react';

import { getServerURL } from '../../utils';
const SERVER_URL = getServerURL();

export default function DiagnosisCodes({ setDiagnosisCode, label }) {
  const [isDiagnosisLoading, setIsDiagnosisLoading] = useState(false);
  const [diagnosisInput, setDiagnosisInput] = useState('');
  const [diagnosisOptions, setDiagnosisOptions] = useState([]);
  useEffect(() => {
    const fetchDiagnosisCodes = async () => {
      setIsDiagnosisLoading(true);
      try {
        const response = await fetch(
          `${SERVER_URL}/get-diagnosis-codes?code=${diagnosisInput}`,
        );
        const json = await response.json();
        setDiagnosisOptions(json);
        setIsDiagnosisLoading(false);
      } catch (e) {
        console.log(`Error fetching diagnosis codes: `, e);
      }
    };
    if (diagnosisInput.length > 3) fetchDiagnosisCodes();
  }, [diagnosisInput]);
  return (
    <FormControl>
      <Autocomplete
        loading={isDiagnosisLoading}
        options={diagnosisOptions}
        onInputChange={(event, value) => {
          setDiagnosisInput(value);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
          />
        )}
        onChange={(event, newValue, reason) => {
          if (reason === 'clear') {
            setDiagnosisCode('');
            return;
          }
          setDiagnosisCode({
            code: newValue.code,
            description: newValue.description,
          });
        }}
        getOptionLabel={(option) => {
          return option.codeDescription;
        }}
      />
    </FormControl>
  );
}
